export default [
  {
    path: "/despesa",
    name: "Despesa",
    component: () => import("../views/DespesaCnpj"),
    meta: { requiresAuth: true },
  },
];
